module.exports = __webpack_public_path__ + "static/regular-d40faac151505344fbab3afb39b6f1b2.woff2";